/* Lumora theme — cart drawer, gallery, tiers, sticky ATC */
(function () {
  'use strict';

  /* ---------------- Cart drawer ---------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var bg = document.querySelector('[data-cart-bg]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-on');
    bg.classList.add('is-on');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-on');
    bg.classList.remove('is-on');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]') || e.target === bg) { closeCart(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  function refreshCart(open) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-refresh' : '/?section_id=cart-refresh')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('[data-cart-refresh-body]');
        var target = document.querySelector('[data-cart-body]');
        if (body && target) target.innerHTML = body.innerHTML;

        var total = doc.querySelector('[data-cart-refresh-total]');
        var totalEl = document.querySelector('[data-cart-total]');
        if (total && totalEl) totalEl.textContent = total.textContent.trim();

        var count = doc.querySelector('[data-cart-refresh-count]');
        if (count) {
          var n = count.textContent.trim();
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
          var lbl = document.querySelector('[data-cart-count-label]');
          if (lbl) lbl.textContent = '(' + n + ')';
          var checkoutBtn = document.querySelector('[name="checkout"]');
          if (checkoutBtn) checkoutBtn.disabled = parseInt(n, 10) === 0;
        }
        if (open) openCart();
      });
  }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* qty +/- and order bump inside drawer (delegated) */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) {
      var row = q.closest('.li');
      var cur = parseInt(row.querySelector('.qty span').textContent, 10);
      var next = q.dataset.qty === '+' ? cur + 1 : cur - 1;
      changeLine(q.dataset.key, Math.max(0, next)).then(function () { refreshCart(false); });
    }
    var bump = e.target.closest('[data-bump]');
    if (bump) {
      bump.textContent = '...';
      addToCart(bump.dataset.bump, 1).then(function () { refreshCart(false); });
    }
  });

  /* ---------------- Product form ---------------- */
  var form = document.querySelector('[data-product-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Toevoegen...';
      var id = form.querySelector('[name="id"]').value;
      var qty = form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1;
      addToCart(id, qty)
        .then(function () { return refreshCart(true); })
        .then(function () { btn.disabled = false; btn.innerHTML = original; })
        .catch(function () { btn.disabled = false; btn.innerHTML = original; });
    });
  }

  /* ---------------- Bundle tiers ---------------- */
  var tiers = document.querySelectorAll('.tier');
  if (tiers.length) {
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
        var input = t.querySelector('input');
        input.checked = true;

        var idField = document.querySelector('[data-variant-id]');
        if (idField && input.dataset.variantId) idField.value = input.dataset.variantId;

        var qtyField = document.querySelector('[data-variant-qty]');
        if (qtyField && input.dataset.qty) qtyField.value = input.dataset.qty;

        var now = document.querySelector('[data-price-now]');
        var was = document.querySelector('[data-price-was]');
        var save = document.querySelector('[data-price-save]');
        if (now && input.dataset.price) now.textContent = input.dataset.price;
        if (was) was.textContent = input.dataset.compare || '';
        if (save) {
          save.textContent = input.dataset.save || '';
          save.style.display = input.dataset.save ? '' : 'none';
        }
        var sp = document.querySelector('[data-sticky-price]');
        if (sp && input.dataset.price) sp.textContent = input.dataset.price;
      });
    });
  }

  /* ---------------- Gallery ---------------- */
  var thumbs = document.querySelectorAll('.gal__thumb');
  var slides = document.querySelectorAll('.gal__slide');
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      slides.forEach(function (s) {
        s.classList.remove('is-active');
        var v = s.querySelector('video');
        if (v) v.pause();
      });
      t.classList.add('is-active');
      if (slides[i]) {
        slides[i].classList.add('is-active');
        var vid = slides[i].querySelector('video');
        if (vid) vid.play().catch(function () {});
      }
    });
  });

  /* ---------------- Sticky ATC ---------------- */
  var sticky = document.querySelector('.sticky-atc');
  var anchor = document.querySelector('[data-atc]');
  if (sticky && anchor) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    sticky.querySelector('[data-sticky-atc]').addEventListener('click', function () {
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }
})();
